import './interactions_view.js.coffee'
Customer.Ticket ||= {}

class Customer.Ticket.ContextInteractionsView extends Customer.Ticket.InteractionsView

  initialize: (@options = {}) ->
    @data = @options
    @ticketView = @data.ticketView
    @ticket = @data.model
    @listenTo(@ticket, 'ticket:contextInteractionsLoaded', @renderInteractions)
    @listenTo(@ticket, 'ticket:moreContextInteractionsLoaded', @renderMore)

  _createInteractionView: (interaction) ->
    new Customer.Ticket.ContextInteractionView(
      model: interaction,
      interactionsView: @
    )

  _hasMore: ->
    @ticket.hasMoreContextInteractions()

  _showMore: ->
    @ticket.loadMoreContextInteractions()
